(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sallve-super-vitc"]) return;
  try {
    
if (!customElements.get('sallve-vitc-landing')) {
  customElements.define('sallve-vitc-landing', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const sticky = this.querySelector('.sticky-purchase');
      const offer = this.querySelector('#oferta-principal');
      const closing = this.querySelector('#comprar');
      let queued = false;
      const update = () => {
        queued = false;
        if (!this.isConnected || !offer || !closing || !sticky) return;
        const rect = closing.getBoundingClientRect();
        const visible = offer.getBoundingClientRect().bottom < 0 && !(rect.top < innerHeight * .7 && rect.bottom > 0);
        sticky.classList.toggle('visible', visible);
      };
      const schedule = () => {
        if (!queued) { queued = true; requestAnimationFrame(update); }
      };
      window.addEventListener('scroll', schedule, {passive:true, signal});
      window.addEventListener('resize', schedule, {passive:true, signal});
      update();
      const params = new URLSearchParams(location.search);
      const allowed = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','fbclid'];
      this.querySelectorAll('form input[name="return_to"]').forEach(input => {
        const url = new URL(input.value, location.origin);
        allowed.forEach(key => { if (params.has(key)) url.searchParams.set(key, params.get(key)); });
        input.value = url.pathname + url.search;
      });
      this.querySelectorAll('.faq-list details').forEach(detail => {
        detail.addEventListener('toggle', () => {
          if (detail.open) this.querySelectorAll('.faq-list details').forEach(other => {
            if (other !== detail) other.open = false;
          });
        }, {signal});
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
